import { useEffect as e, useRef as t } from "react";
//#region src/hooks/useClickOutside.ts
var n = ["mousedown", "touchstart"], r = (e, r = n, a = !0) => {
	let o = t(null);
	return i(o, e, r, a), o;
}, i = (t, r, i = n, a = !0) => {
	e(() => {
		if (!a) return;
		let e = t && "current" in t ? t.current : t, n = (t) => {
			e && !e.contains(t.target) && r(t);
		};
		return i.forEach((e) => {
			document.addEventListener(e, n);
		}), () => {
			i.forEach((e) => {
				document.removeEventListener(e, n);
			});
		};
	}, [
		t,
		r,
		i,
		a
	]);
};
//#endregion
export { n as DEFAULT_EVENT_TYPES, r as default, i as useClickOutsideWithRef };

//# sourceMappingURL=useClickOutside.js.map